import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../app/Api/ApiSlice";
import { toast } from "react-toastify";
import moment from "moment";
import Loader from "../components/Loader";

const UserInvoices = () => {
    const [userInvoices, setUserInvoices] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const { name } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const getInvoices = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/stores/invoices`);
                console.log(response)
                setUserInvoices(response.data || []);
            } catch (error) {
                toast.error(error.response?.data?.message || "Error fetching invoices");
            } finally {
                setIsLoading(false);
            }
        };

        getInvoices();
    }, [name]);

    return (
        <div className="store-user-carts-list">
            <h5>My invoices</h5>

            {!isLoading && userInvoices.length === 0 && (
                <p className="not-found-msg">
                    You have not received any invoice
                </p>
            )}

            {!isLoading && userInvoices.length > 0 && (
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>invoice No</th>
                            <th>Description</th>
                            <th>Items</th>
                            <th>Total Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {userInvoices.map(invoice => (
                            <tr
                                key={invoice._id}
                                onClick={() => navigate(`/b/${invoice.store.name}/invoices/${invoice._id}`)}
                                style={{ cursor: "pointer" }}
                            >
                                <td>{moment(invoice.createdAt).format("DD MM YYYY")}</td>
                                <td>{invoice.invoiceNo}</td>
                                <td>{invoice.store.name}</td>
                                <td>{invoice.description || "No description"}</td>
                                <td>{invoice.items.length}</td>
                                <td>{invoice.total}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
              {isLoading && <Loader />}
        </div>
    );
};

export default UserInvoices;
